
import type { DispatcherWorkplaceInvoice } from '@/modules/DispatcherWorkplaceModule/types'

import type { PropType } from 'vue'

import { defineComponent, onMounted, reactive } from 'vue'

import DwPopup from '@/modules/DispatcherWorkplaceModule/ui/DwPopup/index.vue'
import DwButton from '@/modules/DispatcherWorkplaceModule/ui/DwButton/index.vue'
import DwDate from '@/modules/DispatcherWorkplaceModule/ui/DwDate/index.vue'
import DwSelect from '@/modules/DispatcherWorkplaceModule/ui/DwSelect/index.vue'

import Loader from '@/common/components/UI/Loader/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

import { dispatcherWorkplaceAPI } from '@/modules/DispatcherWorkplaceModule/services'
import useNotifications from '@/common/composable/useNotifications'

export default defineComponent({
    components: {
        DwPopup,
        DwButton,
        DwDate,
        DwSelect,
        Loader,
        TheButton,
    },
    props: {
        date: {
            type: [String, null] as PropType<string | null>,
            default: null
        },
        dispatcherSectorId: {
            type: [Number, null] as PropType<number | null>,
            default: null,
        },
        dispatcherSectors: {
            type: Array as PropType<any[]>,
            default: () => []
        },
        dispatcherSectorsLoading: {
            type: Boolean,
            default: false,
        },
        dispatcherSectorsFailed: {
            type: Boolean,
            default: false,
        }
    },
    emits: ['close'],
    setup(props, { emit }) {
        const notifications = useNotifications()

        const state = reactive({
            dispatcherSectorId: null as number | null,
            date: null as string | null,
            is_loading: false,
            is_failed: false,
            invoices: [] as DispatcherWorkplaceInvoice[]
        })

        const export_state = reactive({
            is_loading: false,
        })

        const onClose = () => {
            emit('close')
        }

        const loadList = async () => {
            try {
                state.is_loading = true

                const response = await dispatcherWorkplaceAPI.getDispatcherWorkplaceInvoices({
                    dispatcherSectorId: state.dispatcherSectorId as number,
                    selfDeliveryDate: state.date as string,
                    isSelfDelivery: 1
                })

                state.invoices = response.data.data

                state.is_failed = false
            } catch (error) {
                console.error(error)
                state.is_failed = true
            } finally {
                state.is_loading = false
            }
        }

        const saveExcel = (content: File | Blob) => {
            const download_url = window.URL.createObjectURL(content)

            const link = document.createElement('a')
            link.href = download_url
            link.setAttribute('download', 'Самопривоз')
            document.body.appendChild(link)
            link.click()
            link.remove()
        }

        const exportInExcel = async () => {
            try {
                export_state.is_loading = true

                const response = await dispatcherWorkplaceAPI.exportExcelList({
                    dispatcherSectorId: state.dispatcherSectorId as number,
                    isSelfDelivery: 1,
                    selfDeliveryDate: state.date,
                    isPickup: 0
                })

                saveExcel(response.data)
            } catch (error) {
                console.error(error)

                notifications.notifyError({ error, title: 'При выгрузке списка самопривоза произошла ошибка '})
            } finally {
                export_state.is_loading = false
            }
        }

        onMounted(() => {
            if (props.dispatcherSectorId) {
                state.dispatcherSectorId = props.dispatcherSectorId
            }

            if (props.date) {
                state.date = props.date
            }

            loadList()
        })

        return {
            state,
            export_state,
            onClose,
            loadList,
            exportInExcel,
        }
    }
})
